import React from "react";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {  Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { GCM_REDEEM_ENABLED, GCM_TERMS_URL } from "@/containers/Participant/GcmShared/routes";

const PARTICIPANT_FOOTER_LINKS = [
  { to: "/participant/about", text: "about_us" },
  { to: "/participant/privacy", text: "privacy" },
    /*
  { to: "/participant/tnc", text: "terms_and_conditions" },
  { to: "/participant/faqs", text: "faqs" }
     */
];

const MANAGER_FOOTER_LINKS = [
  { to: "/manager/about", text: "about_us" },
  { to: "/manager/privacy", text: "privacy" },
    /*
  { to: "/manager/tnc", text: "terms_and_conditions" },
  { to: "/manager/faqs", text: "faqs" }
     */
];

const PUBLIC_FOOTER_LINKS = [
  { to: "/about", text: "about_us" },
  { to: "/privacy", text: "privacy" },
    /*
  { to: "/tnc", text: "terms_and_conditions" },
  { to: "/faqs", text: "faqs" }
     */
];

const Footer = ({links, showGcmTerms = false}) => {
  const { t } = useTranslation();
  return (
    <footer>
      <Container className="footer__wrapper">
        <Row>
          <div className="col-md-6 copyright">
            {t("copyright")} {new Date().getFullYear()}{" "}
            <span className="text-warning text-uppercase">Incentco</span> LLC.{" "}
            {t("all_rights_reserved")}.
          </div>
          <nav className="col-md-6 teritery-menu">
            <ul className="horizontal">
              {links.map((item, index) =>
                <li key={index}>
                  <Link to={item.to} className="link">
                    {t(item.text)}
                  </Link>
                </li>
              )}
              {showGcmTerms && (
                <li>
                  <a href={GCM_TERMS_URL} target="_blank" rel="noreferrer" className="link">
                    {t("gcm_terms_link")}
                  </a>
                </li>
              )}
              <li><a href={"https://incentco.zendesk.com/hc/en-us/requests/new"} className="link">{t("support_request")}</a>
              </li>
            </ul>
          </nav>
        </Row>
      </Container>
    </footer>
  );
};

export const ParticipantFooter = () =>{
  return <Footer links = {PARTICIPANT_FOOTER_LINKS} showGcmTerms={GCM_REDEEM_ENABLED} />
};

export const ManagerFooter = () =>{
  return <Footer links = {MANAGER_FOOTER_LINKS} />
};

export const PublicFooter = () =>{
  return <Footer links = {PUBLIC_FOOTER_LINKS} />
};
